function arrivalDropdown(dropdown, selector) {
	const liNode = dropdown.closest(selector),
		dropdownText = dropdown.querySelector(
			'.dropdown__list-item-text',
		).textContent

	liNode.dataset.date = dropdownText
}
